import React, { useContext, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

import { colors, media } from '../../../utils/styles';
import { Footer, Back, SubmitButton } from '../';
import { QuizContext } from '../../../store/quiz';

const options = ['18-30', '31-45', '46-55', '56-65', '66-79', '80+'];

export const Age = () => {
  const {
    store: { submitAnswer, prevStep, answers, quizLog },
  } = useContext(QuizContext);

  const [age, setAge] = useState([]);

  useEffect(() => {
    setAge(answers['age'] || null);
  }, [answers]);

  const onClick = answer => {
    setAge(answer);
  };

  const onSubmit = () => {
    submitAnswer('age', age);
    quizLog(`Answer_${age}`, 'age');
  };

  return (
    <Wrap>
      <Heading>We know that age is just a number, but which applies to you?</Heading>
      <Buttons>
        {options.map((option, index) => {
          const isSelected = age === option;
          return (
            <Column key={index}>
              <Button onClick={() => onClick(option)} $selected={isSelected}>
                {option}
                {isSelected && (
                  <Icon
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="8" cy="8" r="8" />
                    <path
                      d="M5 8.46L6.78437 10L10.5 6.5"
                      stroke="white"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    />
                  </Icon>
                )}
              </Button>
            </Column>
          );
        })}
      </Buttons>
      <Footer>
        <div>
          <SubmitButton disabled={!age} onClick={onSubmit}>
            Continue
          </SubmitButton>
        </div>
        <Back onBack={prevStep} />
      </Footer>
    </Wrap>
  );
};

const Icon = styled.svg`
  position: absolute;
  top: -7px;
  right: -8px;
  circle {
    fill: ${({ theme }) => theme.primary};
  }
`;

const Buttons = styled.div`
  display: flex;
  margin: -12px -12px 28px;
  justify-content: center;
  flex-wrap: wrap;
  ${media.phone} {
    margin: 0;
  }
`;

const Column = styled.div`
  padding: 12px;
  width: 33.33%;
  ${media.phone} {
    padding: 0;
    width: 100%;
    margin: 0 0 16px;
  }
`;

const Button = styled.button`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 65px;
  background: #f8fafb;
  color: #000000;
  border-radius: 5px;
  border: 2px solid transparent;
  font-weight: bold;
  font-size: 14px;
  transition: none;
  &:hover {
    border-color: ${({ theme }) => theme.primary};
  }
  ${p =>
    p.$selected &&
    css`
      border-color: ${({ theme }) => theme.primary};
      color: ${({ theme }) => theme.primary};
    `}
`;

const Heading = styled.h1`
  font-weight: bold;
  font-size: 32px;
  margin: 0 auto 48px;
  width: 580px;
  max-width: 100%;
  line-height: 43px;
  text-transform: capitalize;
  ${media.phone} {
    margin: 0 0 24px;
    font-size: 28px;
    line-height: 36px;
  }
`;

const Wrap = styled.div`
  text-align: center;
  width: 100%;
  ${media.phone} {
    display: flex;
    flex-direction: column;
  }
`;
